import axios from "axios";
import { instance } from "../Controller/Common";

// AIzaSyATQwEny0bdrMXCd38gDO04q-6U3qQoITA

const extractSingleYoutubeUrl = async (content: string) => {
  const words = content.split(/\s+/);
  const potentialUrl = words.find(
    (word) => word.includes("youtube.com") || word.includes("youtu.be")
  );

  if (!potentialUrl) return 0;

  try {
    const videoUrl = new URL(potentialUrl);
    let videoId = null;

    // Handle different YouTube URL patterns
    switch (videoUrl.hostname) {
      case "youtu.be":
        videoId = videoUrl.pathname.slice(1);
        break;

      case "youtube.com":
      case "www.youtube.com":
        if (videoUrl.pathname === "/watch") {
          videoId = new URLSearchParams(videoUrl.search).get("v");
        } else if (videoUrl.pathname.startsWith("/shorts/")) {
          videoId = videoUrl.pathname.slice(8);
        } else if (videoUrl.pathname.startsWith("/embed/")) {
          videoId = videoUrl.pathname.slice(7);
        }
        break;
    }

    if (videoId && /^[A-Za-z0-9_-]{11}$/.test(videoId)) {
      const result = await GetDuration(potentialUrl);
      return { videoduration: result, url: potentialUrl };
    }

    return 0;
  } catch (error) {
    return 0;
  }
};
const GetVideoIdFromUrl = (url: string): string | null => {
  try {
    const videoUrl = new URL(url);
    let videoId = null;

    switch (videoUrl.hostname) {
      case "youtu.be":
        videoId = videoUrl.pathname.slice(1);
        break;

      case "youtube.com":
      case "www.youtube.com":
        if (videoUrl.pathname === "/watch") {
          videoId = new URLSearchParams(videoUrl.search).get("v");
        } else if (videoUrl.pathname.startsWith("/shorts/")) {
          videoId = videoUrl.pathname.slice(8);
        } else if (videoUrl.pathname.startsWith("/embed/")) {
          videoId = videoUrl.pathname.slice(7);
        }
        break;
    }

    if (videoId && /^[A-Za-z0-9_-]{11}$/.test(videoId)) {
      return videoId;
    }

    return null;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
};

const GetDuration = async (url: string): Promise<number> => {
  const videoId = GetVideoIdFromUrl(url);

  if (!videoId) {
    console.error("Invalid YouTube URL");
    return 0;
  }

  const apiKey = "AIzaSyATQwEny0bdrMXCd38gDO04q-6U3qQoITA";

  try {
    const response = await axios.get(
      `https://www.googleapis.com/youtube/v3/videos?id=${videoId}&part=contentDetails&key=${apiKey}`
    );

    if (!response.data.items || response.data.items.length === 0) {
      console.error("Video not found");
      return 0;
    }

    const duration = response.data.items[0].contentDetails.duration;

    // Updated regex to include hours
    const matches = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);

    if (!matches) {
      throw new Error("Invalid duration format");
    }

    // Get hours, minutes and seconds, default to 0 if not present
    const hours = parseInt(matches[1] || "0");
    const minutes = parseInt(matches[2] || "0");
    const hasSeconds = matches[3] !== undefined;

    // Convert hours to minutes and add everything up
    const totalMinutes = hours * 60 + minutes + (hasSeconds ? 1 : 0);
    return totalMinutes === 0 ? 1 : totalMinutes;
  } catch (error) {
    console.error("Error fetching video duration:", error);
    return 0;
  }
};

const GetPDFCertificate = async (
  userName: string,
  courseName: string,
  date: string,
  certificateId: number
) => {
  try {
    const response = await instance.get(
      `/6D/Course/download?name=${userName}&courseName=${courseName}&date=${date}&certificateId=${certificateId}`,
      { responseType: "blob" }
    );
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Certificate_${userName}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Failed to get certificate:", error);
  }
};

export { extractSingleYoutubeUrl, GetDuration, GetPDFCertificate };
